export var Provider;
(function (Provider) {
    Provider["DIRECT"] = "DIRECT";
    Provider["SAML"] = "SAML";
    Provider["GUILD_AUTH"] = "GUILD_AUTH";
    Provider["GUILD_AUTH_CONSUMER"] = "GUILD_AUTH_CONSUMER";
})(Provider || (Provider = {}));
export var SamlIdentifierField;
(function (SamlIdentifierField) {
    SamlIdentifierField["EMAIL"] = "EMAIL";
    SamlIdentifierField["UNIQUE_ID"] = "UNIQUE_ID";
})(SamlIdentifierField || (SamlIdentifierField = {}));
export var MfaMode;
(function (MfaMode) {
    // SMS = 'SMS', // Commenting out SMS as we don't support it for now
    MfaMode["EMAIL"] = "EMAIL";
})(MfaMode || (MfaMode = {}));
export var FieldType;
(function (FieldType) {
    FieldType["STRING"] = "STRING";
    FieldType["INTEGER"] = "INTEGER";
    FieldType["DECIMAL"] = "DECIMAL";
    FieldType["BOOLEAN"] = "BOOLEAN";
    FieldType["DATE"] = "DATE";
    FieldType["DATE_TIME"] = "DATE_TIME";
})(FieldType || (FieldType = {}));
export var FilterGroupOperator;
(function (FilterGroupOperator) {
    FilterGroupOperator["AND"] = "and";
    FilterGroupOperator["OR"] = "or";
})(FilterGroupOperator || (FilterGroupOperator = {}));
export var FilterConditionOperator;
(function (FilterConditionOperator) {
    FilterConditionOperator["EQUALS"] = "equals";
    FilterConditionOperator["CONTAINS"] = "contains";
    FilterConditionOperator["STARTS_WITH"] = "starts_with";
    FilterConditionOperator["ENDS_WITH"] = "ends_with";
    FilterConditionOperator["MATCH_REGEX"] = "match_regex";
    FilterConditionOperator["GREATER_THAN"] = "greater_than";
    FilterConditionOperator["GREATER_THAN_OR_EQUAL"] = "greater_than_or_equal";
    FilterConditionOperator["LESS_THAN"] = "less_than";
    FilterConditionOperator["LESS_THAN_OR_EQUAL"] = "less_than_or_equal";
    FilterConditionOperator["IN"] = "in";
})(FilterConditionOperator || (FilterConditionOperator = {}));
export var FilterDateOperator;
(function (FilterDateOperator) {
    FilterDateOperator["NOW"] = "now";
    FilterDateOperator["DAY"] = "day";
    FilterDateOperator["MONTH"] = "month";
    FilterDateOperator["YEAR"] = "year";
    FilterDateOperator["DATE"] = "date";
})(FilterDateOperator || (FilterDateOperator = {}));
export var FilterDateDirection;
(function (FilterDateDirection) {
    FilterDateDirection["FROM_NOW"] = "from_now";
    FilterDateDirection["AGO"] = "ago";
})(FilterDateDirection || (FilterDateDirection = {}));
export var FieldDataType;
(function (FieldDataType) {
    FieldDataType["EMAIL"] = "email";
})(FieldDataType || (FieldDataType = {}));
export var ContentType;
(function (ContentType) {
    ContentType["EMAIL"] = "EMAIL";
    ContentType["WEBPAGE"] = "WEBPAGE";
    ContentType["SMS"] = "SMS";
    ContentType["OTHER"] = "OTHER";
    ContentType["PROGRAM_LEVELS"] = "PROGRAM_LEVELS";
    ContentType["FIELDS_OF_STUDY"] = "FIELDS_OF_STUDY";
    ContentType["FEE_TYPES"] = "FEE_TYPES";
})(ContentType || (ContentType = {}));
export var IntegrationConfigType;
(function (IntegrationConfigType) {
    IntegrationConfigType["SFTP"] = "SFTP";
})(IntegrationConfigType || (IntegrationConfigType = {}));
export var IntegrationConfigDirection;
(function (IntegrationConfigDirection) {
    IntegrationConfigDirection["IN"] = "IN";
    IntegrationConfigDirection["OUT"] = "OUT";
})(IntegrationConfigDirection || (IntegrationConfigDirection = {}));
export var TriStateOption;
(function (TriStateOption) {
    TriStateOption["DEFAULT"] = "DEFAULT";
    TriStateOption["YES"] = "YES";
    TriStateOption["NO"] = "NO";
})(TriStateOption || (TriStateOption = {}));
export var RuleTargetType;
(function (RuleTargetType) {
    RuleTargetType["ALL"] = "ALL";
    RuleTargetType["FILTER"] = "FILTER";
})(RuleTargetType || (RuleTargetType = {}));
export var FilterNegateOperator;
(function (FilterNegateOperator) {
    FilterNegateOperator["NOT"] = "not";
})(FilterNegateOperator || (FilterNegateOperator = {}));
export const emptyFilterGroup = {
    op: FilterGroupOperator.AND,
    conditions: [],
    groups: [],
};
export const emptyFilter = {
    id: 0,
    createdAt: '',
    updatedAt: '',
    clientId: 0,
    returnType: '',
    name: '',
    description: '',
    criteria: { ...emptyFilterGroup },
};
export const emptyRule = {
    id: 0,
    clientId: 0,
    createdAt: '',
    updatedAt: '',
    ruleType: '',
    sortOrder: 0,
    policy: {
        ruleType: '',
    },
    isActive: true,
    criteria: {
        op: FilterGroupOperator.AND,
        conditions: [],
        groups: [],
    },
    target: RuleTargetType.ALL,
    isException: false,
};
export const emptyServer = {
    id: 0,
    clientId: 0,
    createdAt: '',
    updatedAt: '',
    name: '',
    hostname: '',
    port: '',
    username: '',
    password: undefined,
    sshKey: undefined,
};
export var Role;
(function (Role) {
    Role["SYS_ADMIN"] = "sys_admin";
    Role["CLIENT_ADMIN"] = "client_admin";
    Role["CLAIMS_PROCESSOR"] = "claims_processor";
    Role["EMPLOYEE"] = "employee";
    Role["MANAGER"] = "manager";
    Role["MEMBER_SUPPORT"] = "member_support";
})(Role || (Role = {}));
export var DocumentEntity;
(function (DocumentEntity) {
    DocumentEntity["PAYMENT_REQUESTS"] = "payment_requests";
})(DocumentEntity || (DocumentEntity = {}));
// TypeScript enum for world currencies
export var Currency;
(function (Currency) {
    Currency["AED"] = "UAE Dirham";
    Currency["AFN"] = "Afghan Afghani";
    Currency["ALL"] = "Albanian Lek";
    Currency["AMD"] = "Armenian Dram";
    Currency["AOA"] = "Angolan Kwanza";
    Currency["ARS"] = "Argentine Peso";
    Currency["AUD"] = "Australian Dollar";
    Currency["AWG"] = "Aruban Florin";
    Currency["AZN"] = "Azerbaijani Manat";
    Currency["BAM"] = "Bosnia-Herzegovina Convertible Mark";
    Currency["BBD"] = "Barbadian Dollar";
    Currency["BDT"] = "Bangladeshi Taka";
    Currency["BGN"] = "Bulgarian Lev";
    Currency["BHD"] = "Bahraini Dinar";
    Currency["BIF"] = "Burundian Franc";
    Currency["BMD"] = "Bermudian Dollar";
    Currency["BND"] = "Brunei Dollar";
    Currency["BOB"] = "Bolivian Boliviano";
    Currency["BRL"] = "Brazilian Real";
    Currency["BSD"] = "Bahamian Dollar";
    Currency["BTN"] = "Bhutanese Ngultrum";
    Currency["BWP"] = "Botswanan Pula";
    Currency["BYN"] = "Belarusian Ruble";
    Currency["BZD"] = "Belize Dollar";
    Currency["CAD"] = "Canadian Dollar";
    Currency["CDF"] = "Congolese Franc";
    Currency["CHF"] = "Swiss Franc";
    Currency["CLP"] = "Chilean Peso";
    Currency["CNY"] = "Chinese Yuan";
    Currency["COP"] = "Colombian Peso";
    Currency["CRC"] = "Costa Rican Col\u00F3n";
    Currency["CUP"] = "Cuban Peso";
    Currency["CVE"] = "Cape Verdean Escudo";
    Currency["CZK"] = "Czech Koruna";
    Currency["DJF"] = "Djiboutian Franc";
    Currency["DKK"] = "Danish Krone";
    Currency["DOP"] = "Dominican Peso";
    Currency["DZD"] = "Algerian Dinar";
    Currency["EGP"] = "Egyptian Pound";
    Currency["ETB"] = "Ethiopian Birr";
    Currency["EUR"] = "Euro";
    Currency["FJD"] = "Fijian Dollar";
    Currency["FKP"] = "Falkland Islands Pound";
    Currency["GBP"] = "British Pound Sterling";
    Currency["GEL"] = "Georgian Lari";
    Currency["GGP"] = "Guernsey Pound";
    Currency["GHS"] = "Ghanaian Cedi";
    Currency["GIP"] = "Gibraltar Pound";
    Currency["GMD"] = "Gambian Dalasi";
    Currency["GNF"] = "Guinean Franc";
    Currency["GTQ"] = "Guatemalan Quetzal";
    Currency["GYD"] = "Guyanese Dollar";
    Currency["HKD"] = "Hong Kong Dollar";
    Currency["HNL"] = "Honduran Lempira";
    Currency["HTG"] = "Haitian Gourde";
    Currency["HUF"] = "Hungarian Forint";
    Currency["IDR"] = "Indonesian Rupiah";
    Currency["ILS"] = "Israeli New Shekel";
    Currency["IMP"] = "Isle of Man Pound";
    Currency["INR"] = "Indian Rupee";
    Currency["IQD"] = "Iraqi Dinar";
    Currency["IRR"] = "Iranian Rial";
    Currency["ISK"] = "Icelandic Kr\u00F3na";
    Currency["JEP"] = "Jersey Pound";
    Currency["JMD"] = "Jamaican Dollar";
    Currency["JOD"] = "Jordanian Dinar";
    Currency["JPY"] = "Japanese Yen";
    Currency["KES"] = "Kenyan Shilling";
    Currency["KGS"] = "Kyrgyzstani Som";
    Currency["KHR"] = "Cambodian Riel";
    Currency["KMF"] = "Comorian Franc";
    Currency["KRW"] = "South Korean Won";
    Currency["KWD"] = "Kuwaiti Dinar";
    Currency["KYD"] = "Cayman Islands Dollar";
    Currency["KZT"] = "Kazakhstani Tenge";
    Currency["LAK"] = "Lao Kip";
    Currency["LBP"] = "Lebanese Pound";
    Currency["LKR"] = "Sri Lankan Rupee";
    Currency["LRD"] = "Liberian Dollar";
    Currency["LSL"] = "Lesotho Loti";
    Currency["LYD"] = "Libyan Dinar";
    Currency["MAD"] = "Moroccan Dirham";
    Currency["MDL"] = "Moldovan Leu";
    Currency["MGA"] = "Malagasy Ariary";
    Currency["MKD"] = "North Macedonian Denar";
    Currency["MMK"] = "Myanmar Kyat";
    Currency["MNT"] = "Mongolian Tugrik";
    Currency["MOP"] = "Macanese Pataca";
    Currency["MRU"] = "Mauritanian Ouguiya";
    Currency["MWK"] = "Malawian Kwacha";
    Currency["MVR"] = "Maldivian Rufiyaa";
    Currency["MXN"] = "Mexican Peso";
    Currency["MYR"] = "Malaysian Ringgit";
    Currency["MZN"] = "Mozambican Metical";
    Currency["NAD"] = "Namibian Dollar";
    Currency["NGN"] = "Nigerian Naira";
    Currency["NIO"] = "Nicaraguan C\u00F3rdoba";
    Currency["NOK"] = "Norwegian Krone";
    Currency["NPR"] = "Nepalese Rupee";
    Currency["NZD"] = "New Zealand Dollar";
    Currency["OMR"] = "Omani Rial";
    Currency["PAB"] = "Panamanian Balboa";
    Currency["PEN"] = "Peruvian Sol";
    Currency["PGK"] = "Papua New Guinean Kina";
    Currency["PHP"] = "Philippine Peso";
    Currency["PKR"] = "Pakistani Rupee";
    Currency["PLN"] = "Polish Z\u0142oty";
    Currency["PYG"] = "Paraguayan Guaran\u00ED";
    Currency["QAR"] = "Qatari Riyal";
    Currency["RON"] = "Romanian Leu";
    Currency["RUB"] = "Russian Ruble";
    Currency["RSD"] = "Serbian Dinar";
    Currency["RWF"] = "Rwandan Franc";
    Currency["SAR"] = "Saudi Riyal";
    Currency["SBD"] = "Solomon Islands Dollar";
    Currency["SCR"] = "Seychellois Rupee";
    Currency["SDG"] = "Sudanese Pound";
    Currency["SEK"] = "Swedish Krona";
    Currency["SGD"] = "Singapore Dollar";
    Currency["SHP"] = "Saint Helena Pound";
    Currency["SLE"] = "Sierra Leonean Leone";
    Currency["SOS"] = "Somali Shilling";
    Currency["SRD"] = "Surinamese Dollar";
    Currency["STN"] = "S\u00E3o Tom\u00E9 and Pr\u00EDncipe Dobra";
    Currency["SVC"] = "Salvadoran Col\u00F3n";
    Currency["SZL"] = "Swazi Lilangeni";
    Currency["THB"] = "Thai Baht";
    Currency["TJS"] = "Tajikistani Somoni";
    Currency["TMT"] = "Turkmenistani Manat";
    Currency["TND"] = "Tunisian Dinar";
    Currency["TOP"] = "Tongan Pa'anga";
    Currency["TRY"] = "Turkish Lira";
    Currency["TTD"] = "Trinidad and Tobago Dollar";
    Currency["TWD"] = "New Taiwan Dollar";
    Currency["TZS"] = "Tanzanian Shilling";
    Currency["UAH"] = "Ukrainian Hryvnia";
    Currency["UGX"] = "Ugandan Shilling";
    Currency["USD"] = "United States Dollar";
    Currency["UYU"] = "Uruguayan Peso";
    Currency["UZS"] = "Uzbekistani Som";
    Currency["VES"] = "Venezuelan Bol\u00EDvar";
    Currency["VND"] = "Vietnamese Dong";
    Currency["VUV"] = "Vanuatu Vatu";
    Currency["XAF"] = "Central African Cfa Franc";
    Currency["XCD"] = "East Caribbean Dollar";
    Currency["XOF"] = "West African Cfa Franc";
    Currency["XPF"] = "Cfp Franc";
    Currency["YER"] = "Yemeni Rial";
    Currency["ZMW"] = "Zambian Kwacha";
    Currency["ZAR"] = "South African Rand";
})(Currency || (Currency = {}));
